export const LAST_UPDATED_COLUMN_FIELD = "updated_at";
export const AUDIT_LAST_UPDATED_COLUMN_FIELD = "audit.updated_at";
export const LAST_UPDATED_COLUMN_TITLE = "Last Updated";
export const TABLE_AUTOUPDATE_TIMEOUT = 30000;
